import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";

import { useGetBoxMovements } from "../apis";
import { EInventoryBoxZone } from "../constants";
import { GetBoxMovementsParams } from "../transfers.types";

const useBoxMovementsList = () => {
  const {
    page,
    sorting,
    searchValue,
    debouncedSearch,
    setSearchValue,
    setSorting,
    setPage,
  } = useManageTable({
    defaultSorting: [{ id: "createdAt", desc: true }],
  });

  const [zone, setZone] = useState<EInventoryBoxZone | undefined>(undefined);

  useEffect(() => {
    setPage(1);
  }, [zone, debouncedSearch]);

  const requestParams: GetBoxMovementsParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      zone,
      search: debouncedSearch || undefined,
    }),
    [page, sorting, zone, debouncedSearch],
  );

  const { boxMovements, meta, isLoading, refetch } =
    useGetBoxMovements(requestParams);

  return {
    boxMovements,
    totalItems: meta?.itemCount ?? 0,
    page,
    isLoading,
    sorting,
    zone,
    searchValue,
    setSearchValue,
    setZone,
    setSorting,
    setPage,
    refetch,
  };
};

export default useBoxMovementsList;
